import type { CoreQuestionResource } from '@dmp/qqms/data-access';
import type {
    LinearAnswerState,
    LinearQuestionState,
} from '../state/state-types';

/****************************************************************
 * Transform/Flatten Core Question Config List to State
 ****************************************************************/
export const coreQuestionResourceListToState = (
    coreQuestions: CoreQuestionResource[]
) => {
    return {
        questions: transformToCardsState(coreQuestions),
        answers: transformToAnswersState(coreQuestions),
    };
};

/**
 * Collect & transform questions resource to array of questions
 */
export const transformToCardsState = (
    coreQuestions: CoreQuestionResource[]
): LinearQuestionState[] => {
    return coreQuestions.map((c) => ({
        ...c.attributes.config,
        type: 'linearQuestion',
        id: c.id,
        answerIds: c.attributes.config.answers.map((a) => a.id),
    }));
};

/**
 * Collect & transform answers resource to array of answers
 */
export const transformToAnswersState = (
    coreQuestions: CoreQuestionResource[]
): Array<LinearAnswerState> =>
    coreQuestions.map((c) => c.attributes.config.answers).flat();
